/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type ToursPageQueryVariables = {
    count?: number | null;
    cursor?: unknown | null;
};
export type ToursPageQueryResponse = {
    readonly invites: {
        readonly edges: ReadonlyArray<{
            readonly cursor: unknown | null;
            readonly node: {
                readonly id: string;
            } | null;
        } | null> | null;
    };
    readonly me: {
        readonly user: {
            readonly company: {
                readonly license: {
                    readonly planName: string | null;
                    readonly monthlyActiveTours: number | null;
                    readonly monthlyUploadedTours: number | null;
                    readonly uploadLimit: number | null;
                    readonly quantity: number;
                } | null;
            } | null;
            readonly " $fragmentRefs": FragmentRefs<"TruvuToursContainer_user" | "Tours_user" | "ToursAdd_user">;
        } | null;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"Tours_tours">;
};
export type ToursPageQuery = {
    readonly response: ToursPageQueryResponse;
    readonly variables: ToursPageQueryVariables;
};



/*
query ToursPageQuery(
  $count: Int = 10
  $cursor: Cursor
) {
  ...Tours_tours
  invites {
    edges {
      cursor
      node {
        id
      }
    }
  }
  me {
    user {
      ...TruvuToursContainer_user
      ...Tours_user
      ...ToursAdd_user
      company {
        license {
          planName
          monthlyActiveTours
          monthlyUploadedTours
          uploadLimit
          quantity
          id
        }
        id
      }
      id
    }
  }
}

fragment TourCard_tour on Tour {
  id
  title
  views
  createdAt
  description
  videoURL
  thumbnailURL
  reels {
    id
    key
    progress
    seed
    provider
    highURI
    thumbnailURL
    status {
      status
      id
    }
  }
  status {
    status
    id
  }
  logs {
    status
    error
    id
  }
}

fragment TourMemberCard_tour on Tour {
  id
  title
  views
  createdAt
  description
  videoURL
  thumbnailURL
  reels {
    provider
    id
  }
  status {
    status
    id
  }
  logs {
    status
    error
    id
  }
}

fragment ToursAdd_user on User {
  company {
    license {
      monthlyActiveTours
      monthlyUploadedTours
      uploadLimit
      quantity
      id
    }
    id
  }
}

fragment Tours_tours on Query {
  tours(first: $count, after: $cursor) {
    edges {
      cursor
      node {
        id
        status {
          status
          id
        }
        ...TourCard_tour
        __typename
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      startCursor
      endCursor
    }
  }
}

fragment Tours_user on User {
  id
  monthlyUploadedTours
  monthlyActiveTours
  topFiveTours {
    id
    title
    thumbnailURL
    views
    deactivatedViews
  }
  profile {
    email
    id
  }
  company {
    invites {
      accepted
      createdAt
      email
      expiresAt
      user {
        user {
          profile {
            email
            name
            surname
            id
          }
          topFiveTours {
            ...TourMemberCard_tour
            id
            views
          }
          id
        }
      }
      id
    }
    license {
      planName
      monthlyActiveTours
      monthlyUploadedTours
      uploadLimit
      quantity
      id
    }
    id
  }
}

fragment TruvuToursContainer_user on User {
  profile {
    name
    surname
    profileImageURL
    id
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": 10,
    "kind": "LocalArgument",
    "name": "count"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cursor"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "concreteType": "TeamInviteConnection",
  "kind": "LinkedField",
  "name": "invites",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "TeamInviteEdge",
      "kind": "LinkedField",
      "name": "edges",
      "plural": true,
      "selections": [
        (v1/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "TeamInvite",
          "kind": "LinkedField",
          "name": "node",
          "plural": false,
          "selections": [
            (v2/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "planName",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthlyActiveTours",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "monthlyUploadedTours",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "uploadLimit",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "quantity",
  "storageKey": null
},
v9 = [
  {
    "kind": "Variable",
    "name": "after",
    "variableName": "cursor"
  },
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v11 = [
  (v10/*: any*/),
  (v2/*: any*/)
],
v12 = {
  "alias": null,
  "args": null,
  "concreteType": "TourProgress",
  "kind": "LinkedField",
  "name": "status",
  "plural": false,
  "selections": (v11/*: any*/),
  "storageKey": null
},
v13 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "title",
  "storageKey": null
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "views",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "createdAt",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "description",
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "videoURL",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "thumbnailURL",
  "storageKey": null
},
v19 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "provider",
  "storageKey": null
},
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "TourLog",
  "kind": "LinkedField",
  "name": "logs",
  "plural": true,
  "selections": [
    (v10/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "error",
      "storageKey": null
    },
    (v2/*: any*/)
  ],
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "surname",
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "email",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "ToursPageQuery",
    "selections": [
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "License",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "TruvuToursContainer_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "Tours_user"
              },
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "ToursAdd_user"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "Tours_tours"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ToursPageQuery",
    "selections": [
      {
        "alias": null,
        "args": (v9/*: any*/),
        "concreteType": "TourConnection",
        "kind": "LinkedField",
        "name": "tours",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "TourEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Tour",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v12/*: any*/),
                  (v13/*: any*/),
                  (v14/*: any*/),
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/),
                  (v18/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "Reel",
                    "kind": "LinkedField",
                    "name": "reels",
                    "plural": true,
                    "selections": [
                      (v2/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "key",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "progress",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "seed",
                        "storageKey": null
                      },
                      (v19/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "highURI",
                        "storageKey": null
                      },
                      (v18/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "ReelProgress",
                        "kind": "LinkedField",
                        "name": "status",
                        "plural": false,
                        "selections": (v11/*: any*/),
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  (v20/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "__typename",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasPreviousPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "startCursor",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      },
      {
        "alias": null,
        "args": (v9/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "Tours_tours",
        "kind": "LinkedHandle",
        "name": "tours"
      },
      (v3/*: any*/),
      {
        "alias": null,
        "args": null,
        "concreteType": "Me",
        "kind": "LinkedField",
        "name": "me",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "User",
            "kind": "LinkedField",
            "name": "user",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "UserProfile",
                "kind": "LinkedField",
                "name": "profile",
                "plural": false,
                "selections": [
                  (v21/*: any*/),
                  (v22/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "profileImageURL",
                    "storageKey": null
                  },
                  (v2/*: any*/),
                  (v23/*: any*/)
                ],
                "storageKey": null
              },
              (v2/*: any*/),
              (v6/*: any*/),
              (v5/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "Tour",
                "kind": "LinkedField",
                "name": "topFiveTours",
                "plural": true,
                "selections": [
                  (v2/*: any*/),
                  (v13/*: any*/),
                  (v18/*: any*/),
                  (v14/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "deactivatedViews",
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "concreteType": "Company",
                "kind": "LinkedField",
                "name": "company",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "TeamInvite",
                    "kind": "LinkedField",
                    "name": "invites",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "accepted",
                        "storageKey": null
                      },
                      (v15/*: any*/),
                      (v23/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "expiresAt",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "TeamInviteUser",
                        "kind": "LinkedField",
                        "name": "user",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "User",
                            "kind": "LinkedField",
                            "name": "user",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "UserProfile",
                                "kind": "LinkedField",
                                "name": "profile",
                                "plural": false,
                                "selections": [
                                  (v23/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v2/*: any*/)
                                ],
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "Tour",
                                "kind": "LinkedField",
                                "name": "topFiveTours",
                                "plural": true,
                                "selections": [
                                  (v2/*: any*/),
                                  (v13/*: any*/),
                                  (v14/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v18/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "Reel",
                                    "kind": "LinkedField",
                                    "name": "reels",
                                    "plural": true,
                                    "selections": [
                                      (v19/*: any*/),
                                      (v2/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v12/*: any*/),
                                  (v20/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v2/*: any*/)
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "License",
                    "kind": "LinkedField",
                    "name": "license",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/),
                      (v6/*: any*/),
                      (v7/*: any*/),
                      (v8/*: any*/),
                      (v2/*: any*/)
                    ],
                    "storageKey": null
                  },
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "d96f3c15f94539cc549f4b628f1855a2",
    "id": null,
    "metadata": {},
    "name": "ToursPageQuery",
    "operationKind": "query",
    "text": "query ToursPageQuery(\n  $count: Int = 10\n  $cursor: Cursor\n) {\n  ...Tours_tours\n  invites {\n    edges {\n      cursor\n      node {\n        id\n      }\n    }\n  }\n  me {\n    user {\n      ...TruvuToursContainer_user\n      ...Tours_user\n      ...ToursAdd_user\n      company {\n        license {\n          planName\n          monthlyActiveTours\n          monthlyUploadedTours\n          uploadLimit\n          quantity\n          id\n        }\n        id\n      }\n      id\n    }\n  }\n}\n\nfragment TourCard_tour on Tour {\n  id\n  title\n  views\n  createdAt\n  description\n  videoURL\n  thumbnailURL\n  reels {\n    id\n    key\n    progress\n    seed\n    provider\n    highURI\n    thumbnailURL\n    status {\n      status\n      id\n    }\n  }\n  status {\n    status\n    id\n  }\n  logs {\n    status\n    error\n    id\n  }\n}\n\nfragment TourMemberCard_tour on Tour {\n  id\n  title\n  views\n  createdAt\n  description\n  videoURL\n  thumbnailURL\n  reels {\n    provider\n    id\n  }\n  status {\n    status\n    id\n  }\n  logs {\n    status\n    error\n    id\n  }\n}\n\nfragment ToursAdd_user on User {\n  company {\n    license {\n      monthlyActiveTours\n      monthlyUploadedTours\n      uploadLimit\n      quantity\n      id\n    }\n    id\n  }\n}\n\nfragment Tours_tours on Query {\n  tours(first: $count, after: $cursor) {\n    edges {\n      cursor\n      node {\n        id\n        status {\n          status\n          id\n        }\n        ...TourCard_tour\n        __typename\n      }\n    }\n    pageInfo {\n      hasNextPage\n      hasPreviousPage\n      startCursor\n      endCursor\n    }\n  }\n}\n\nfragment Tours_user on User {\n  id\n  monthlyUploadedTours\n  monthlyActiveTours\n  topFiveTours {\n    id\n    title\n    thumbnailURL\n    views\n    deactivatedViews\n  }\n  profile {\n    email\n    id\n  }\n  company {\n    invites {\n      accepted\n      createdAt\n      email\n      expiresAt\n      user {\n        user {\n          profile {\n            email\n            name\n            surname\n            id\n          }\n          topFiveTours {\n            ...TourMemberCard_tour\n            id\n            views\n          }\n          id\n        }\n      }\n      id\n    }\n    license {\n      planName\n      monthlyActiveTours\n      monthlyUploadedTours\n      uploadLimit\n      quantity\n      id\n    }\n    id\n  }\n}\n\nfragment TruvuToursContainer_user on User {\n  profile {\n    name\n    surname\n    profileImageURL\n    id\n  }\n}\n"
  }
};
})();
(node as any).hash = '8a438986dddbf84346a15fbe360f92ec';
export default node;
